import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { LogoutLink } from "../auth/LogoutLink";
import { selectUser } from "../reducers/userSlice";
import logo_dark from "../assets/logos/logo-1-dark.svg";
import { ambiente_produccion, produccion } from "../utils/Datos";

const Header = ({ setmenuMobileState }) => {
  const [menuAbierto, setmenuAbierto] = useState(false);
  const [menuMobileAbierto, setmenuMobileAbierto] = useState(false);

  const [nombreUsuario, setnombreUsuario] = useState("Cargando datos");
  const [emailUsuario, setemailUsuario] = useState("Cargando datos");
  const menuRef = useRef();
  const user = useSelector(selectUser);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick, true);
    if (user !== null) {
      console.log(user);
      setnombreUsuario(user.user.name);
      setemailUsuario(user.email);
    }
  }, [user]);

  const handleMenu = () => {
    console.log("menuAbierto");
    console.log(menuAbierto);
    if (!menuAbierto) {
      setmenuAbierto(true);
    } else {
      setmenuAbierto(false);
    }
  };

  const handleMenuMobile = () => {
    console.log("menuAbiertoMobile");
    if (!menuMobileAbierto) {
      console.log(menuMobileAbierto);
      //setmenuMobileAbierto(true);
      setmenuMobileState(true);
    } else {
      console.log(menuMobileAbierto);
      //setmenuMobileAbierto(false);
      setmenuMobileState(false);
    }
  };

  const ambiente_productivo=ambiente_produccion;

  const handleOutsideClick = (e) => {
    try {
      if (!menuRef.current.contains(e.target)) {
        setmenuAbierto(false);
      }
    } catch (error) {}
  };

  console.log("setmenuMobileState");
  console.log(typeof setmenuMobileState);

  return (
    <div id="kt_header" className="header align-items-stretch">
      <div className="container-fluid d-flex align-items-stretch justify-content-between">
        <div
          className="d-flex align-items-center d-lg-none ms-n2 me-2"
          title="Show aside menu"
        >
          <div
            className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
            id="kt_aside_mobile_toggle"
            onClick={handleMenuMobile}
          >
            <span className="svg-icon svg-icon-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                  fill="currentColor"
                />
                <path
                  opacity="0.3"
                  d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </div>
        </div>

        <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
          <a href="index.html" className="d-lg-none">
            <img
              alt="Logo"
              src={logo_dark}
              className="h-30px"
            />
          </a>
        </div>
        <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
          <div className="d-flex align-items-stretch" id="kt_header_nav">
            <div
              className="header-menu align-items-stretch"
              data-kt-drawer="true"
              data-kt-drawer-name="header-menu"
              data-kt-drawer-activate="{default: true, lg: false}"
              data-kt-drawer-overlay="true"
              data-kt-drawer-width="{default:'200px', '300px': '250px'}"
              data-kt-drawer-direction="end"
              data-kt-drawer-toggle="#kt_header_menu_mobile_toggle"
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}"
            >
              <div
                className="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch"
                id="#kt_header_menu"
                data-kt-menu="true"
              >
                <div
                  data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-start"
                  className="menu-item menu-lg-down-accordion me-lg-1 d-none"
                >
                  <span className="menu-link py-3">
                    <span className="menu-title">Dashboard</span>
                    <span className="menu-arrow d-lg-none"></span>
                  </span>
                </div>

                <div
                  data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-start"
                  className="menu-item  menu-lg-down-accordion me-lg-1 d-none"
                >
                  <span className="menu-link py-3">
                    <span className="menu-title">Boton 2</span>
                    <span className="menu-arrow d-lg-none"></span>
                  </span>
                  <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">
                    <div
                      data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                      data-kt-menu-placement="right-start"
                      className="menu-item menu-lg-down-accordion"
                    >
                      <span className="menu-link py-3">
                        <span className="menu-icon">
                          <span className="svg-icon svg-icon-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M18 21.6C16.6 20.4 9.1 20.3 6.3 21.2C5.7 21.4 5.1 21.2 4.7 20.8L2 18C4.2 15.8 10.8 15.1 15.8 15.8C16.2 18.3 17 20.5 18 21.6ZM18.8 2.8C18.4 2.4 17.8 2.20001 17.2 2.40001C14.4 3.30001 6.9 3.2 5.5 2C6.8 3.3 7.4 5.5 7.7 7.7C9 7.9 10.3 8 11.7 8C15.8 8 19.8 7.2 21.5 5.5L18.8 2.8Z"
                                fill="currentColor"
                              />
                              <path
                                opacity="0.3"
                                d="M21.2 17.3C21.4 17.9 21.2 18.5 20.8 18.9L18 21.6C15.8 19.4 15.1 12.8 15.8 7.8C18.3 7.4 20.4 6.70001 21.5 5.60001C20.4 7.00001 20.2 14.5 21.2 17.3ZM8 11.7C8 9 7.7 4.2 5.5 2L2.8 4.8C2.4 5.2 2.2 5.80001 2.4 6.40001C2.7 7.40001 3.00001 9.2 3.10001 11.7C3.10001 15.5 2.40001 17.6 2.10001 18C3.20001 16.9 5.3 16.2 7.8 15.8C8 14.2 8 12.7 8 11.7Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                        </span>
                        <span className="menu-title">Sub 1</span>
                        <span className="menu-arrow"></span>
                      </span>
                      <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                        <div className="menu-item">
                          <a className="menu-link py-3" href="#/">
                            <span className="menu-bullet">
                              <span className="bullet bullet-dot"></span>
                            </span>
                            <span className="menu-title">Sub 1.1</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                      data-kt-menu-placement="right-start"
                      className="menu-item here show menu-lg-dropdown"
                    >
                      <span className="menu-link py-3">
                        <span className="menu-icon">
                          <span className="svg-icon svg-icon-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                opacity="0.3"
                                d="M21 22H14C13.4 22 13 21.6 13 21V3C13 2.4 13.4 2 14 2H21C21.6 2 22 2.4 22 3V21C22 21.6 21.6 22 21 22Z"
                                fill="currentColor"
                              />
                              <path
                                d="M10 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H10C10.6 2 11 2.4 11 3V21C11 21.6 10.6 22 10 22Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                        </span>
                        <span className="menu-title">Sub 2</span>
                        <span className="menu-arrow"></span>
                      </span>
                      <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                        <div className="menu-item">
                          <a className="menu-link py-3" href="#l">
                            <span className="menu-bullet">
                              <span className="bullet bullet-dot"></span>
                            </span>
                            <span className="menu-title">Sub 2.1</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-stretch flex-shrink-0">
            <div className="d-flex align-items-center ms-1 ms-lg-3">
                  {
                    !ambiente_productivo ? <h4 className="text-warning"><i className="fas fa-exclamation-triangle mr-2 text-warning"></i>AMBIENTE DE DESARROLLO</h4>: <></>
                  }
            </div>
            <div
              className="d-flex align-items-center ms-1 ms-lg-3"
              id="kt_header_user_menu_toggle"
            >
              {!menuAbierto ? (
                <div
                  onClick={handleMenu}
                  className="cursor-pointer symbol symbol-30px symbol-md-40px menu-dropdown"
                  data-kt-menu-trigger="click"
                  data-kt-menu-attach="parent"
                  data-kt-menu-placement="bottom-end"
                >
                  <Avatar nombreUsuario={nombreUsuario}></Avatar>
                </div>
              ) : (
                <></>
              )}
              <div
                ref={menuRef}
                style={{ marginTop: 200 }}
                className={
                  menuAbierto
                    ? "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px show"
                    : "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
                }
                data-kt-menu="true"
              >
               
                <div className="menu-item px-3">
                  <div className="menu-content d-flex align-items-center px-3">
                    <div className="me-5">
                      <Avatar nombreUsuario={nombreUsuario}></Avatar>
                    </div>
                    <div className="d-flex flex-column">
                      <div className="fw-bolder d-flex align-items-center fs-5">
                        {nombreUsuario}
                      </div>
                      <a
                        href="#/"
                        className="fw-bold text-muted text-hover-primary fs-7"
                      >
                        {emailUsuario}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="separator my-2"></div>

                <div className="menu-item px-5 d-none">
                  <a className="menu-link px-5">Mi perfil</a>
                </div>

                <div className="separator my-2"></div>

                <div className="menu-item px-5">
                  <LogoutLink className="menu-link px-5"></LogoutLink>
                </div>
                <div className="separator my-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Avatar = ({ nombreUsuario }) => {
  return <div className="circuloAvatar">{nombreUsuario[0]}</div>;
};

export default Header;
